<template>
   <div id="mappa"  >
      
      <div class="mapcontainer" id="map">
        <iframe
  width="100%"
  height="100%"
  style="border:0"
  loading="lazy"
  allowfullscreen
  src="https://www.google.com/maps/embed/v1/place?key=AIzaSyCQ0w7R7_kPYEMYo5rJzyhlHX8o1t5uXP4&q=Newlab+Genova">
</iframe>
          <div class="arrow_up"><a href="#newlabapp"><img src="@/assets/images/arrow_up.svg"></a></div>
      </div>
      
   </div> 

   
</template>

<script>

import multilangmixin from "../mixins/multilangmixin.js"
import companymixin from "../mixins/companymixin.js"
   

export default {
  name: "cmpcontatti",
  mixins:[multilangmixin,companymixin],
  
  data(){
      return {

             
              
            };
  },


  created(){
    //console.log("created ",this.$options.name, "   lingua: ",this.currentlang);

  },


  mounted(){
 
  },

  computed:{
      
       
 
      linkcasestudies()
      {
        return "/"+this.currentlang+"/casestudies";
      },

      dicosahaibisognolabel(){
        return this.fnGetTranslation(this.currentlang,"dicosahaibisogno");
      },
      siamoquipertelabel(){
        return this.fnGetTranslation(this.currentlang,"siamoquiperte");
      },
      simadovelabel(){
        return this.fnGetTranslation(this.currentlang,"simadove");
      }
      

  },


  methods:{
      
      
   

  }

  

}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    
   
   
 
 .withopacity{
   color: #00000025;
   transition: 0.7s;

 }


.sottolineato{

    
    text-decoration: underline;
    text-decoration-style: solid;
    /*text-decoration-color: #ffdd00;*/
    
    text-decoration-thickness: 0.1em;    
    /* line-height: 7vh; */
    /* text-underline-offset: 1vh;*/


}
     




.activelink
{
    color: white; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    

}
 
.activelink:visited{

  color: white; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
}

.activelink:active{

  color: white; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
}

.activelink:hover{

    color: white; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
}






.normallink
{
    color: black; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    

}
 
.normallink:visited{

  color: black; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
}

.normallink:active{

  color: black; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
}

.normallink:hover{

    color: white; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
}

 


  @media screen and (min-width: 600px)    {
      /*  schermo desktop */
    
       


      .mapcontainer{
          height: 80vh;
      }
 

      .arrow_up{
        position: absolute;
        right: 5vh;
        bottom: 20vh;
        
      }



  }
  
  @media screen and (max-width: 600px) {
     /*  schermo mobile */
  
      .mapcontainer{
          height: 80vh;
      }

   
    .arrow_up{
      position: absolute;
      right: 5vh;
      bottom: 30vh;
      
    }
 

    .arrow_up a img{
        width: 10vw;    
    }
  }


</style>
